export default __webpack_public_path__ + "static/media/black-folder.803d8cbe.svg";